module.exports = __webpack_public_path__ + "static/media/fwzc_3.788381a4.jpg";